module.exports = __webpack_public_path__ + "fonts/fa-brands-400---f4920c94c0861c537f72ba36590f6362.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff
// module id = 376
// module chunks = 0